

import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  dropdownWrapper: {
    position: 'relative',
    display: 'inline-block'
  },
  optionsList: function optionsList(props) {return {
      margin: [0],
      position: 'absolute',
      width: props.optionsWidth || '32rem',
      backgroundColor: colors.neutral.white,
      borderRadius: '6px',
      listStyle: 'none',
      zIndex: 100,
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.14)',
      padding: [0],
      overflow: 'hidden',
      letterSpacing: '0.02rem'
    };},
  bottomLeft: {
    top: 'calc(100% + 0.4rem)',
    right: 0
  },
  bottomRight: {
    top: 'calc(100% + 0.4rem)',
    left: 0
  },
  topLeft: {
    bottom: 'calc(100% + 0.4rem)',
    right: 0
  },
  topRight: {
    bottom: 'calc(100% + 0.4rem)',
    left: 0
  },
  option: {
    font: {
      family: 'Lato, sans-serif',
      size: '1.2rem',
      lineHeight: '1.8rem',
      weight: 400
    },
    boxSizing: 'border-box',
    padding: {
      top: '1.6rem',
      bottom: '1.6rem',
      left: '2.4rem',
      right: '2.4rem'
    },
    color: colors.neutral[900],
    cursor: 'pointer',
    '&:last-of-type': {
      '&::after': {
        display: 'none'
      }
    },
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: colors.blue[100]
    },
    '&:active': {
      backgroundColor: colors.blue[600],
      color: colors.neutral.white,
      '&::after': {
        display: 'none'
      }
    },
    '&::after': {
      content: '""',
      display: 'block',
      height: '0.5px',
      width: '100%',
      backgroundColor: colors.neutral[400],
      position: 'relative',
      bottom: '-1.6rem'
    }
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map